// extracted by mini-css-extract-plugin
export default {"priceListPreviewModal":"style_priceListPreviewModal__RIrz-","priceListPreviewModalBody":"style_priceListPreviewModalBody__Wr3-E"};